import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,

} from "@angular/core";

import { VehiclesService } from "../../../../shared/services/vehicles.service";
import { TiposerviciosDocumentosService } from "../../../../shared/services/tiposerviciosdocumento.service";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbAccordion, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { NgbdSortableHeader } from "../../../../shared/directives/NgbdSortableHeader";
import { ActivatedRoute } from "@angular/router";
import { Utils } from "../../../../shared/utils/Utils";
import jsPDF from "jspdf";
declare var require: any;
const Swal = require('sweetalert2')
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { Administracion } from "../../../../shared/model/administracion.model";
import { AdministracionService } from "../../../../shared/services/administracion.services";

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.scss']
})
export class DocumentosComponent implements OnInit {

  public isFechas: boolean = false;
  public isVencidos: boolean = false;
  public isVencer: boolean = false;
  public isVigentes: boolean = false;

  @ViewChild('myModal3') myModal3!: TemplateRef<any>;
  @ViewChild("inputServicio") inputServicio!: ElementRef;
  @ViewChild("inputPlaca") inputPlaca!: ElementRef;
  @ViewChild("inputInterno") inputInterno!: ElementRef;
  @ViewChild("inputEmpresa") inputEmpresa!: NgSelectComponent;
  @ViewChild("inputClase") inputClase!: NgSelectComponent;
  @ViewChild("inputMarca") inputMarca!: NgSelectComponent;
  @ViewChild("inputModelo") inputModelo!: NgSelectComponent;
  @ViewChild("inputRelacion") inputRelacion!: NgSelectComponent;
  @ViewChild("inputPassword") inputPassword!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;


  pageSize1: number = 10;
  page1: number = 1;
  totalItems!: number;


  activePanel: string[] = ["static-1"]; // El panel se abre por defecto
  formData: any = {}; // Inicializar vacío para evitar errores
  empresas!: any[];
  todasLasEmpresas: any;
  marcas: any;
  tipos: any;
  propietarios: any;
  formNuevo!: FormGroup;
  validate: boolean = false;
  errores: any = {};
  relaciones: any;
  modelos: any;
  formTarjeta!: FormGroup;
  formSoat!: FormGroup;
  formCda!: FormGroup;
  formExtintor!: FormGroup;
  empresasaseguradora: any;
  empresascda: any;
  formBimestral!: FormGroup;
  formContractual!: FormGroup;
  formExtracontractual!: FormGroup;
  formTodoriesgo!: FormGroup;
  combustibles: any;
  editMode!: boolean;
  formEmpresa!: FormGroup;
  empresaselecionada: any;
  formClase!: FormGroup;
  claseselecionada: any;
  tiposervicio: any;

  validarTO: boolean = false; // Variable de control para el ngIf
  validarBIM: boolean = false;
  validarLT: boolean = false;
  validarRCC: boolean = false;
  validarSOAT: boolean = false;
  validarCDA: boolean = false;
  validarRCE: boolean = false;
  validarPTR: boolean = false;
  editarSeleccion: any;
  formConductor!: FormGroup;
  botonListarDisponible: boolean = false;
  modelo: any;
  formModelo!: FormGroup;
  modeloSeleccionado: any;
  vehicles: any;
  statusCounts: any;
  estadoDeshabilitado = true;
  documentosVencidos: any[] = [];
  documentosPorVencer: any[] = [];
  documentosVigentes: any[] = [];
  documentosSinFecha: any[] = [];
  maxDate!: string;
  minDate!: string;
  administraciones: Administracion[] = [];
  empresaId: any;
  placasModal: string[] = []; // 🔹 Aquí guardaremos las placas para el modal
  tituloModal: string = '';
  selectedDocumentList: { placa: string; fecha: string }[] = [];
  loadingSinFecha: boolean = false;
  loadingVencidos: boolean = false;
  loadingPorVencer: boolean = false;
  loadingVigentes: boolean = false;
  altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;

  // Hacer que el calendario se cierre al hacer clic fuera del componente
  @HostListener("document:click", ["$event"])
  clickout(event: MouseEvent) {
    const calendar = document.querySelector(".ngb-datepicker");
    if (calendar && !calendar.contains(event.target as Node)) {
      // Aquí el calendario se cierra automáticamente
      // Este comportamiento está controlado por autoClose='outside'
    }
  }

  constructor(
    private vehiclesService: VehiclesService,
    private tiposerviciodocumentoService: TiposerviciosDocumentosService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private gpcGoogle: gpcGoogleService,
    private administracionesServices: AdministracionService,
    private modalService: NgbModal
  ) { }


  ngOnInit() {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    this.minDate = formattedDate;
    this.maxDate = formattedDate;

    this.listarVehiculosActivos();
    this.cargarDataAdmin();
  }
  // Función para reiniciar el formulario de vehículo
  onSubmit() {
   /*  if (this.formNuevo.valid) {
    } else {
      console.log("Formulario inválido");
    }
    if (this.formConductor.valid) {
      const conductorId = this.formConductor.value.conductor_id;
      console.log("Conductor seleccionado:", conductorId);
      // Aquí puedes proceder con la lógica para guardar o utilizar la selección
    } */
  }


  Actualizar() {
    // Extraemos la propiedad placa antes de actualizar
    const vehicleData = this.formNuevo.value;
    const placa = this.editarSeleccion?.placa;

    if (!placa) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Placa no encontrada. No se puede actualizar.",
      });
      return;
    }

    if (this.editMode) {
      // **Actualizar vehículo existente**
      this.vehiclesService.updateVehicle(placa, vehicleData).subscribe({
        next: (response) => {
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "Vehículo actualizado.",
          });
        },
        error: (err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: err.message || "Error al actualizar.",
          });
        },
      });
    }
  }

  listarVehiculosActivos(): void {
  this.loadingSinFecha = true;
  this.loadingVencidos = true;
  this.loadingPorVencer = true;
  this.loadingVigentes = true;
  this.vehiclesService.getAllActiveVehiclesWithStatusCounts().subscribe({
      next: (data) => {
        console.log(data);
        this.vehicles = data.vehicles;
        this.statusCounts = data.statusCounts;
 // 🚫 Excluir extintores para vehículos con clase 12, 19 o 20
        this.ajustarConteosExtintores();
        if (!this.vehicles || this.vehicles.length === 0) {
          console.log('🚫 No hay vehículos activos.');
        } else {
       //   console.log('✅ Vehículos activos cargados:', this.vehicles);

          this.documentosVencidos = [
            { nombre: 'TARJETA DE OPERACIÓN', total: this.statusCounts.tarjetasOperaciones.vencidos },
            { nombre: 'SOAT', total: this.statusCounts.historialSoat.vencidos },
            { nombre: 'REVISIÓN TÉCNICO MECÁNICA', total: this.statusCounts.historialCda.vencidos },
            { nombre: 'REVISIÓN BIMESTRAL', total: this.statusCounts.historialBimestral.vencidos },
            { nombre: 'PÓLIZAS CONTRACTUAL', total: this.statusCounts.historialContractual.vencidos },
            { nombre: 'PÓLIZAS EXTRACONTRACTUAL', total: this.statusCounts.historialExtraContractual.vencidos },
            { nombre: 'EXTINTOR', total: this.statusCounts.historialExtintor.vencidos }
          ];
          setTimeout(() => {
            this.loadingVencidos = false;
          }, 300);

          this.documentosPorVencer = [
            { nombre: 'TARJETA DE OPERACIÓN', total: this.statusCounts.tarjetasOperaciones.porVencer },
            { nombre: 'SOAT', total: this.statusCounts.historialSoat.porVencer },
            { nombre: 'REVISIÓN TÉCNICO MECÁNICA', total: this.statusCounts.historialCda.porVencer },
            { nombre: 'REVISIÓN BIMESTRAL', total: this.statusCounts.historialBimestral.porVencer },
            { nombre: 'PÓLIZAS CONTRACTUAL', total: this.statusCounts.historialContractual.porVencer },
            { nombre: 'PÓLIZAS EXTRACONTRACTUAL', total: this.statusCounts.historialExtraContractual.porVencer },
            { nombre: 'EXTINTOR', total: this.statusCounts.historialExtintor.porVencer }
          ];
          setTimeout(() => {
            this.loadingPorVencer = false;
          }, 300);

          // 🔵 NUEVO: Documentos Vigentes
          this.documentosVigentes = [
            { nombre: 'TARJETA DE OPERACIÓN', total: this.statusCounts.tarjetasOperaciones.vigentes },
            { nombre: 'SOAT', total: this.statusCounts.historialSoat.vigentes },
            { nombre: 'REVISIÓN TÉCNICO MECÁNICA', total: this.statusCounts.historialCda.vigentes },
            { nombre: 'REVISIÓN BIMESTRAL', total: this.statusCounts.historialBimestral.vigentes },
            { nombre: 'PÓLIZAS CONTRACTUAL', total: this.statusCounts.historialContractual.vigentes },
            { nombre: 'PÓLIZAS EXTRACONTRACTUAL', total: this.statusCounts.historialExtraContractual.vigentes },
            { nombre: 'EXTINTOR', total: this.statusCounts.historialExtintor.vigentes }
          ];
          setTimeout(() => {
            this.loadingVigentes = false;
          }, 300);

          // 🟠 NUEVO: Documentos Sin Fecha
          this.documentosSinFecha = [
            { nombre: 'TARJETA DE OPERACIÓN', total: this.statusCounts.tarjetasOperaciones.sinFecha },
            { nombre: 'SOAT', total: this.statusCounts.historialSoat.sinFecha },
            { nombre: 'REVISIÓN TÉCNICO MECÁNICA', total: this.statusCounts.historialCda.sinFecha },
            { nombre: 'REVISIÓN BIMESTRAL', total: this.statusCounts.historialBimestral.sinFecha },
            { nombre: 'PÓLIZAS CONTRACTUAL', total: this.statusCounts.historialContractual.sinFecha },
            { nombre: 'PÓLIZAS EXTRACONTRACTUAL', total: this.statusCounts.historialExtraContractual.sinFecha },
            { nombre: 'EXTINTOR', total: this.statusCounts.historialExtintor.sinFecha }
          ];
          // Simular carga para mostrar skeleton
          setTimeout(() => {
            this.loadingSinFecha = false;
          }, 300);
        }
      },
      error: (error) => {
        console.error('❌ Error cargando vehículos activos:', error);
      }
    });
  }

  /**
   * Ajusta los conteos de extintores excluyendo vehículos con clase 12, 19 o 20
   */
  private ajustarConteosExtintores(): void {
    if (!this.statusCounts || !this.statusCounts.historialExtintor) {
      return;
    }

    // Clases de vehículos a excluir (motos y similares)
    const clasesExcluidas = [12, 19, 20];

    // Obtener placas de vehículos con clases excluidas
    const placasExcluidas = this.vehicles
      .filter(v => clasesExcluidas.includes(v.clase))
      .map(v => v.placa);

    console.log(`🚫 Placas excluidas de conteo de extintor (clases ${clasesExcluidas.join(', ')}):`, placasExcluidas);

    // Ajustar conteos y placas para cada estado
    ['vencidos', 'porVencer', 'vigentes', 'sinFecha'].forEach(estado => {
      if (this.statusCounts.historialExtintor.placas && this.statusCounts.historialExtintor.placas[estado]) {
        const placasOriginales = this.statusCounts.historialExtintor.placas[estado];
        const placasFiltradas = placasOriginales.filter((placa: string) => !placasExcluidas.includes(placa));
        
        // Actualizar placas filtradas
        this.statusCounts.historialExtintor.placas[estado] = placasFiltradas;
        
        // Actualizar conteo
        this.statusCounts.historialExtintor[estado] = placasFiltradas.length;

        // Si hay fechas asociadas, también filtrarlas
        if (this.statusCounts.historialExtintor.fechas && this.statusCounts.historialExtintor.fechas[estado]) {
          const fechasFiltradas = this.statusCounts.historialExtintor.fechas[estado].filter(
            (_: any, index: number) => !placasExcluidas.includes(placasOriginales[index])
          );
          this.statusCounts.historialExtintor.fechas[estado] = fechasFiltradas;
        }

        console.log(`✅ ${estado}: ${placasOriginales.length} → ${placasFiltradas.length} (excluidas: ${placasOriginales.length - placasFiltradas.length})`);
      }
    });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

exportarExcel(tableId: string, fileName: string) {
  const element = document.getElementById(tableId);
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

  // Recorremos las celdas para convertir fechas a texto formateado
  const range = XLSX.utils.decode_range(ws['!ref']!);
  for(let R = range.s.r + 1; R <= range.e.r; ++R) { // +1 para saltar el header
    const cell_address = {c: 1, r: R}; // columna B (índice 1) -> Fecha
    const cell_ref = XLSX.utils.encode_cell(cell_address);
    const cell = ws[cell_ref];

    if(cell && cell.t === 'n') { 
      // Celda es numérica (fecha en Excel es número)
      const date = XLSX.SSF.parse_date_code(cell.v);
      if(date) {
        // Formatear fecha a string "dd/mm/yyyy"
        const formattedDate = 
          String(date.d).padStart(2,'0') + '/' + 
          String(date.m).padStart(2,'0') + '/' + 
          date.y;

        // Reemplazar valor con texto y cambiar tipo a texto
        cell.v = formattedDate;
        cell.t = 's';
      }
    }
  }

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, fileName + '.xlsx');
}



  exportarDocumentosSinFecha(estado: string): void {
    this.vehiclesService.descargarPorEstado(estado);
  }

  getDiasRestantes = (vencelic: Date): number => {
    if (!vencelic) return NaN; // Manejar valores nulos o indefinidos

    const hoy = new Date();
    const fechaVencimiento = new Date(vencelic);
    const diferenciaDias = Math.ceil((fechaVencimiento.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24));

    return diferenciaDias;
  }

  addHeader(doc: jsPDF, title: string) {
    const pageWidth = 230;       // Ancho total en mm (Letter)
    const marginLeft = 5;       // Margen izquierdo deseado
    const marginRight = 5;      // Margen derecho igual para simetría
    const rectY = 3;            // Distancia desde la parte superior
    const headerHeight = 20;     // Altura del encabezado
    const rectWidth = pageWidth - marginLeft - marginRight;

    // Dibujar el rectángulo del encabezado
    doc.setDrawColor(0, 0, 0);   // Borde negro
    doc.setLineWidth(0.5);       // Grosor del borde
    doc.rect(marginLeft, rectY, rectWidth, headerHeight);

    // Título centrado dentro del rectángulo
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);

    const text = title;
    const centerX = marginLeft + rectWidth / 2;
    const textY = rectY + 12; // Ajuste vertical para ubicar el texto dentro del rectángulo

    doc.text(text, centerX, textY, { align: "center" });
  }

  async addHeaderImages(
    doc: jsPDF,
    gpcGoogle: any,
    imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>
  ) {
    const getSignedUrlSafe = async (path: string) => {
      try {
        const res = await gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };

    const getImageBase64Safe = async (url: string | null) => {
      if (!url) return null;
      try {
        return await gpcGoogle.getImageBase64(url);
      } catch {
        return null;
      }
    };

    const imageKeys = Object.entries(imageMap);
    const signedUrls = await Promise.all(
      imageKeys.map(([_, img]) => getSignedUrlSafe(img.path))
    );

    const base64Images = await Promise.all(
      signedUrls.map((url) => getImageBase64Safe(url))
    );

    base64Images.forEach((base64, idx) => {
      const { x, y, w, h } = imageKeys[idx][1];
      if (base64) {
        doc.addImage(base64, "JPG", x, y, w, h, undefined, "FAST");
      } else {
        // Mostrar texto si no se pudo cargar la imagen
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text("SIN SOPORTE CARGADO", x + 2, y + h / 2, { maxWidth: w });
      }
    });
  }
  async ExportarListadoVehiculos() {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [230, 280], // 🔷 ancho 230mm, alto 280mm (más ancho que "letter")
      compress: true,
    });

    const imgUrl = "../../../../../assets/images/hoja_vida/banner.jpg";
    //const imgLogo = "../../../../../assets/images/hoja_vida/logo.png";

    this.addHeader(doc, 'VENCIMIENTOS DE DOCUMENTOS');
    await this.addHeaderImages(doc, this.gpcGoogle, {
      supertransporte: { path: "ministerio/supertransporte.png", x: 175, y: 5, w: 40, h: 14 },
      logo: { path: `${this.empresaId}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
    },);

    Promise.all([
      this.getBase64Image(imgUrl),
      //this.getBase64Image(imgLogo)
    ]).then(([bannerBase64]) => {

      // 🔶 Encabezado superior con logos y título centrado
      const altoFila2 = 18;
      let filaY2 = 10;
      let xActual2 = 5;

      // 🔶 Título principal con fondo gris oscuro y texto blanco
      const tituloAltura = 10;
      const tituloY = filaY2 + altoFila2 + 2;

      doc.setFillColor(60, 60, 60); // gris oscuro
      doc.rect(5, tituloY, 220, tituloAltura, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text(
        "LISTADO GENERAL DE DOCUMENTOS POR VEHÍCULO",
        115,
        tituloY + 6,
        { align: "center" }
      );

      // 🔶 Posición inicial después del título
      let filaY = tituloY + tituloAltura;

      // Declarar columnas y anchos una sola vez
      let columnas: string[];
      let anchos: number[];
      if (Number(this.administraciones[0].urlApiWhatsapp) === 1) {
        columnas = [
          "ITEM",
          "PLACA",          
          "SOAT",
          "RTM",
         
          "POL. RCC",
          "POL. RCE",
          "EXTINTOR",
          
        ];
        anchos = [12, 35, 35, 35, 35, 35, 32];
      } else {
        columnas = [
          "ITEM",
          "PLACA",
          "T. OPERACIÓN",
          "SOAT",
          "RTM",
          "BIMESTRAL",
          "POL. RCC",
          "POL. RCE",
          "EXTINTOR",
          "CONVENIOS",
        ];
        anchos = [12, 22, 23, 23, 22, 23, 23, 23, 24, 25];
      }
      const altoFila = 7;

      const dibujarEncabezadoTabla = () => {
        let x = 5;
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);

        columnas.forEach((col, i) => {
          doc.setFillColor(220, 220, 220); // fondo gris claro
          doc.rect(x, filaY, anchos[i], altoFila, "F");
          const textWidth = doc.getTextWidth(col);
          doc.text(col, x + (anchos[i] - textWidth) / 2, filaY + 5);
          x += anchos[i];
        });

        filaY += altoFila;
      };

      dibujarEncabezadoTabla();

      // 🔶 Filas de datos
      this.vehicles.forEach((veh, index) => {
        if (filaY > 260) {
          doc.addPage();
          this.addFooter(doc);
          filaY = 20;
          dibujarEncabezadoTabla();
        }

          

      if (Number(this.administraciones[0].urlApiWhatsapp) === 1){
         const formatDate = (val: any) => {
           if (!val) return "SIN FECHA";
           // Si la fecha viene como string 'YYYY-MM-DD', evitar desfase por zona horaria
           if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
             const [year, month, day] = val.split('-').map(Number);
             return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
           }
           const d = new Date(val);
           if (isNaN(d.getTime())) return val;
           return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth()+1).toString().padStart(2, '0')}/${d.getFullYear()}`;
         };
         const fila = [
          (index + 1).toString(),
          veh.placa || "SIN FECHA",
          formatDate(veh.historialSoat?.[0]?.vencimiento_soat),
          formatDate(veh.historialCda?.[0]?.vcda),
          formatDate(veh.historialContractual?.[0]?.fecha_vencimientoRCC),
          formatDate(veh.historialExtraContractual?.[0]?.fecha_vencimientoRCE),
          formatDate(veh.historialExtintor?.[0]?.vrecarga),
        ];
          let xFila = 5;

        fila.forEach((val, colIndex) => {
          const ancho = anchos[colIndex];
          doc.setFont("helvetica", "normal");
          doc.setFontSize(8);

          let color: [number, number, number] = [0, 0, 0];
          if (colIndex > 1 && val && val !== "SIN FECHA") {
            const fecha = new Date(val);
            if (!isNaN(fecha.getTime())) {
              const hoy = new Date();
              const dias =
                (fecha.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24);
              if (dias < 0) {
                color = [200, 0, 0]; // rojo
              } else if (dias <= 30) {
                color = [253, 119, 0]; // naranja
              }
            }
          }

          doc.setTextColor(...color);

          doc.rect(xFila, filaY, ancho, altoFila);
          const texto =
            val === "SIN FECHA" || val === "SIN FECHA/SIN FECHA"
              ? "SIN FECHA"
              : String(val);
          const textWidth = doc.getTextWidth(texto);
          const textX = xFila + (ancho - textWidth) / 2;
          doc.text(texto, textX, filaY + 5);
          xFila += ancho;
        });

        filaY += altoFila;
      }else{
        const formatDate = (val: any) => {
          if (!val) return "SIN FECHA";
          const d = new Date(val);
          if (isNaN(d.getTime())) return val;
          return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth()+1).toString().padStart(2, '0')}/${d.getFullYear()}`;
        };
        const fila = [
          (index + 1).toString(),
          veh.placa || "SIN FECHA",
          veh.servicio == 2 ? "N/A" : formatDate(veh.tarjetasOperaciones?.[0]?.fecha_vencimiento),
          formatDate(veh.historialSoat?.[0]?.vencimiento_soat),
          formatDate(veh.historialCda?.[0]?.vcda),
          veh.servicio === 2 ? "N/A" : formatDate(veh.historialBimestral?.[0]?.proxima_revision),
          formatDate(veh.historialContractual?.[0]?.fecha_vencimientoRCC),
          formatDate(veh.historialExtraContractual?.[0]?.fecha_vencimientoRCE),
          formatDate(veh.historialExtintor?.[0]?.vrecarga),
          veh.relacion==8?  formatDate(veh.convenio) : "N/A"
        ];
          let xFila = 5;

        fila.forEach((val, colIndex) => {
          const ancho = anchos[colIndex];
          doc.setFont("helvetica", "normal");
          doc.setFontSize(8);

          let color: [number, number, number] = [0, 0, 0];
          if (colIndex > 1 && val && val !== "SIN FECHA") {
            const fecha = new Date(val);
            if (!isNaN(fecha.getTime())) {
              const hoy = new Date();
              const dias =
                (fecha.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24);
              if (dias < 0) {
                color = [200, 0, 0]; // rojo
              } else if (dias <= 30) {
                color = [253, 119, 0]; // naranja
              }
            }
          }

          doc.setTextColor(...color);

          doc.rect(xFila, filaY, ancho, altoFila);
          const texto =
            val === "SIN FECHA" || val === "SIN FECHA/SIN FECHA"
              ? "SIN FECHA"
              : String(val);
          const textWidth = doc.getTextWidth(texto);
          const textX = xFila + (ancho - textWidth) / 2;
          doc.text(texto, textX, filaY + 5);
          xFila += ancho;
        });

        filaY += altoFila;
      }
      //  console.log(veh);
     

      
      });

      // 🔶 Footer
      this.addFooter(doc);

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    });
  }

  // 🔹 Función para agregar footer correctamente
  addFooter(doc: jsPDF) {
    const pageHeight = doc.internal.pageSize.height; // ✅ Obtener altura de la página correctamente
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("Hoja de Vida Generada by Admin SEAF - indesoftsas.com", 105, pageHeight - 8, { align: "center" });
  }


  getBase64Image(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("No context");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
    });
  }

  private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {

        this.administraciones = data;
        this.empresaId = this.administraciones[0].nit;
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.x;   // 10
        this.posicionY = data[0].dimensionLogo.y;  
       // console.log(this.empresaId);
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }

  // Suponiendo que tienes el JSON guardado en una variable llamada 'datosDocumentos'
  abrirModal(nombreDocumento: string, estado: string) {
    const keyMap: any = {
      'TARJETA DE OPERACIÓN': 'tarjetasOperaciones',
      'SOAT': 'historialSoat',
      'REVISIÓN TÉCNICO MECÁNICA': 'historialCda',
      'REVISIÓN BIMESTRAL': 'historialBimestral',
      'PÓLIZAS CONTRACTUAL': 'historialContractual',
      'PÓLIZAS EXTRACONTRACTUAL': 'historialExtraContractual',
      'EXTINTOR': 'historialExtintor'
    };

    this.tituloModal = `${nombreDocumento} - ${estado.toUpperCase()}`;
    const key = keyMap[nombreDocumento];
    if (!key || !this.statusCounts[key]) {
      console.warn('Documento no encontrado en statusCounts');
      this.selectedDocumentList = [];
      return;
    }
   // console.log(this.statusCounts[key]);
   // console.log(estado.toLowerCase());
   // console.log(this.statusCounts[key][estado]);
    if (this.statusCounts[key][estado] > 0) {
      // Obtener placas para el estado dado (en minúsculas)
      this.placasModal = this.statusCounts[key].placas[estado] || [];
      const fechas = this.statusCounts[key].fechas ? this.statusCounts[key].fechas[estado] : [];

      // Combinar placas y fechas
      this.selectedDocumentList = this.placasModal.map((placa: string, i: number) => ({
        placa,
        fecha: fechas[i] || 'Sin fecha',
      }));

      //console.log('Listado placa+fecha:', this.selectedDocumentList);

      // Abrir modal
      this.modalService.open(this.myModal3, { size: 'lg' });
    } else {
      //mensaje al usuario
      Swal.fire({
        icon: "info",
        title: "Sin datos",
        text: `El documento "${nombreDocumento}" no posee datos disponibles.`,
        confirmButtonText: 'Aceptar',
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          Swal.hideLoading();
        }
      });
      return;
    }
  }

  // 🔹 Cerrar modal
  cerrarModal(): void {
    const modal = document.getElementById('placasModal');
    if (modal) {
      (modal as any).style.display = 'none';
    }
  }

}